module.exports = __webpack_public_path__ + "static/media/card-flip.affcda3a.mp3";